import { Map, fromJS } from 'immutable';

import {
    PROMO_CODES_INITIALIZE, PROMO_CODE_DETAIL_INITIALIZE, PROMO_CODE_LIST_INITIALIZE,
    PROMO_CODES_FETCH_REQUEST, PROMO_CODES_FETCH_SUCCESS, PROMO_CODES_FETCH_ERROR,
    PROMO_CODE_FETCH_REQUEST, PROMO_CODE_FETCH_SUCCESS, PROMO_CODE_FETCH_ERROR,
} from './promo-codes-actions';

const initialState = fromJS({
    detail_primary: {},
    list_primary: {}
});

/**
 * Promo Codes Reducer
 */

const promoCodes = (state = initialState, action) => {
    let newState;

    // Get list and detail context
    const list = `list_${(action && action.context) || `primary`}`;
    const detail = `detail_${(action && action.context) || `primary`}`;

    switch (action.type) {

        // Initialize
        case PROMO_CODES_INITIALIZE:
            newState = state
                .setIn([detail], Map({}))
                .setIn([list], Map({}));
            return newState;

        case PROMO_CODE_DETAIL_INITIALIZE:
            newState = state
                .setIn([detail], Map({}));
            return newState;

        case PROMO_CODE_LIST_INITIALIZE:
            newState = state
                .setIn([list], Map({}));
            return newState;

        // Promo Codes Fetch (list)
        case PROMO_CODES_FETCH_REQUEST:

            newState = state;

            // Promo Codes fetch request only use "list" options
            // Delete created, update, deleted keys if exists
            if (state.getIn([list, 'created'])) newState = newState.removeIn([list, 'created']);
            if (state.getIn([list, 'updated'])) newState = newState.removeIn([list, 'updated']);
            if (state.getIn([list, 'deleted'])) newState = newState.removeIn([list, 'deleted']);

            newState = newState
                .mergeIn([list], Map({
                    isFetching: action.isFetching,
                    error: action.error
                }));
            return newState;
        case PROMO_CODES_FETCH_SUCCESS:
            newState = state.mergeIn([list], Map({
                isFetching: action.isFetching,
                error: action.error,
                payload: fromJS(action.payload)
            }));
            return newState;
        case PROMO_CODES_FETCH_ERROR:
            newState = state.mergeIn([list], Map({
                isFetching: action.isFetching,
                error: action.error,
                errorMessage: action.errorMessage
            }));
            return newState;


        // Promo Code Fetch (detail)
        case PROMO_CODE_FETCH_REQUEST:

            newState = state;

            // Promo Code fetch request only use "detail" options
            // Delete created, update, deleted keys if exists
            if (state.getIn([detail, 'created'])) newState = newState.removeIn([detail, 'created']);
            if (state.getIn([detail, 'updated'])) newState = newState.removeIn([detail, 'updated']);
            if (state.getIn([detail, 'deleted'])) newState = newState.removeIn([detail, 'deleted']);

            newState = newState
                .mergeIn([detail], Map({
                    isFetching: action.isFetching,
                    error: action.error
                }));
            return newState;
        case PROMO_CODE_FETCH_SUCCESS:

            newState = state.mergeIn([detail], Map({
                isFetching: action.isFetching,
                error: action.error,
                payload: fromJS(action.payload)
            }));
            return newState;

        case PROMO_CODE_FETCH_ERROR:

            newState = state.mergeIn([detail], Map({
                isFetching: action.isFetching,
                error: action.error,
                errorMessage: action.errorMessage
            }));
            return newState;

        default:
            return state;
    }
};

export default promoCodes;
